import React, {memo} from "react";
import PropTypes from "prop-types";
import {GridActionsCellItem} from "@mui/x-data-grid";
import StyledTooltip from "../tooltips/StyledTooltip";
import {actionCellSx, disabledActionCellSx} from "./actionStyles";

export const ActionCell = memo(({actionType, label, icon, onClick, disabled}) => (
  <GridActionsCellItem
    label={label}
    onClick={onClick}
    icon={<StyledTooltip title={label}>{icon}</StyledTooltip>}
    aria-label={label}
    disabled={disabled}
    id={actionType}
    size="large"
    sx={disabled ? disabledActionCellSx : actionCellSx}
  />
));

ActionCell.propTypes = {
  actionType: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export const CustomActionCell = memo(({label, icon, onClick, disabled}) => (
  <GridActionsCellItem
    label={label}
    onClick={onClick}
    icon={<StyledTooltip title={label}>{icon}</StyledTooltip>}
    aria-label={label}
    disabled={disabled}
    id={label?.replaceAll(" ", "-").toLowerCase()}
    size="large"
    sx={disabled ? disabledActionCellSx : actionCellSx}
  />
));

CustomActionCell.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};
